module.exports = __webpack_public_path__ + "img/239.compressor_drainage.0f3242c8.svg";